import reducer from "./reducer";
export { default as OrganizationalBenefits } from "./components/index";
export { default as organizationalBenefitsReducerName } from "./constants";
export default reducer;
